import { LiveScoreSubscription } from "../types";
import { isValidLiveScoreObjecSubscription } from "./typeguards";
import { getTransformedDay, IdayType } from "./utils";
import { WidgetError, ErrorName } from "../../../utils/errors";
import { ISport, IMotorsportsLiveScore } from "@sky-it-livedata/livedata-sports-design-system"
import { UpdateLiveScoreWidgetInputSchema} from 'cdk/graphql';

type IMotorsportsLiveScorePartial = Omit<IMotorsportsLiveScore, 'previousDay' | 'nextDay'>;

const transformer = (obj: LiveScoreSubscription): IMotorsportsLiveScorePartial => {
  if (isValidLiveScoreObjecSubscription(obj)) {
    UpdateLiveScoreWidgetInputSchema().parse(obj.data.onUpdateLiveScoreWidgetById, {reportInput: true});
    const { currentDay } = obj.data.onUpdateLiveScoreWidgetById;

    const transformedObject = {
      currentDay: getTransformedDay({
        day: currentDay as ISport[],
        type: IdayType.PARTIAL,
      }),
    };

    return transformedObject as IMotorsportsLiveScorePartial;
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message:
        "Invalid transformer input, Error in LiveScoreSubscription object",
      data: obj,
    });
  }
};

export default transformer;
